import React from "react";
import NextLink from "next/link";
import { forwardRef, Link as ChakraLink, type LinkProps as ChakraLinkProps } from "@chakra-ui/react";
import { noFollowDomains } from "../../constants/no-follow-domains";

export type LinkProps = Omit<ChakraLinkProps, "href"> & {
  href?: string | undefined;
};

export const Link = forwardRef<LinkProps, "a">((props, ref) => {
  const { href, children } = props;

  if (!href) {
    return (
      <ChakraLink ref={ref} {...props}>
        {children}
      </ChakraLink>
    );
  }

  const hasNofollow = noFollowDomains.some((noFollowDomain) => href.includes(noFollowDomain));

  return (
    <ChakraLink ref={ref} as={NextLink} href={href} rel={hasNofollow ? "nofollow noopener" : undefined} {...props}>
      {children}
    </ChakraLink>
  );
});
